import { BaseModel } from 'src/app/@shared/base.model';
import { Cluster } from '@api/cluster/@shared/cluster.entity';
import { ClusterModel } from 'src/app/cluster/@shared/cluster.model';
import { Organization } from '@api/organization/@shared/organization.entity';
import { OrganizationModel } from 'src/app/organization/@shared/organization.model';
import { Person } from '@api/person/@shared/person.entity';
import { PersonModel } from 'src/app/person/@shared/person.model';
import {
  Protocol,
  ProtocolSnapshot,
  ProtocolledEntity,
  ProtocolledEntityType,
} from '@api/protocol/@shared/protocol.entity';
import { Topic } from '@api/topic/@shared/topic.entity';
import { TopicModel } from 'src/app/topic/@shared/topic.model';
import { UserModel } from 'src/app/user/@shared/user.model';

export type ProtocolledModel = OrganizationModel | PersonModel | TopicModel | ClusterModel;

export class ProtocolModel extends BaseModel<Protocol> {
  public editorName: string;
  public editor: UserModel;
  public updatedFieldsContent: Partial<ProtocolledEntity>;
  public previousState: ProtocolledModel | null;
  public editedFields: string[];
  public editedEntityId: string;
  public editedEntityType: ProtocolledEntityType;

  constructor(source: Protocol) {
    super(source);

    this.editor = new UserModel(source.editor);
    this.editedFields = source.editedFields;
    this.editedEntityId = source.editedEntityId;
    this.editedEntityType = source.editedEntityType;

    this.setEditorName();
    this.updatedFieldsContent = source.updatedFieldsState;
    this.previousState = this.getStateAsModel(source.previousState || null);
  }

  private setEditorName(): void {
    if (this.editor.alias) {
      this.editorName = this.editor.alias;

      return;
    }

    if (this.editor.firstname) {
      this.editorName = `${this.editor.firstname} ${this.editor.lastname}`;
      this.editorName.trimEnd();

      return;
    }
    this.editorName = this.editor.email;
  }

  private getStateAsModel(entity: ProtocolSnapshot | null): ProtocolledModel | null {
    if (!entity) {
      return null;
    }

    switch (this.editedEntityType) {
      case 'organization':
        return new OrganizationModel(entity as unknown as Organization);

      case 'person':
        return new PersonModel(entity as unknown as Person);

      case 'topic':
        return new TopicModel(entity as unknown as Topic);

      case 'cluster':
        return new ClusterModel(entity as unknown as Cluster);

      default:
        console.error('ProtocolDetailPage: getAsModel() - entity type not supported:', this.editedEntityType);

        return null;
    }
  }
}
